module.exports = __webpack_public_path__ + "static/media/r-md17.291a858c.png";